/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import { List, URL, User, UserAPIToken, UserAPITokenExtended } from "./data-contracts";

/**
 * @description Returns details about the user associated with the authentication provided in the request's authorization header.
 * @tags users
 * @name GetAuthenticatedUser
 * @summary Get profile of authenticated user
 * @request GET:/user
 * @secure
 */

// @ts-ignore
export const getAuthenticatedUser: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {};
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: User;
  ResponseStatusCode: 200 | 404;
} = {
  route: "/user",
  method: "get",
  streaming: false,
  tags: ["users"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags users, internal
 * @name ListApiTokens
 * @summary List API tokens for the currently authenticated user
 * @request GET:/user/tokens
 * @secure
 */

// @ts-ignore
export const listAPITokens: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {};
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: UserAPIToken[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/user/tokens",
  method: "get",
  streaming: false,
  tags: ["users", "internal"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags users, internal
 * @name CreateApiToken
 * @summary Create a new API token for the currently authenticated user
 * @request POST:/user/tokens
 * @secure
 */

// @ts-ignore
export const createAPIToken: {
  route: string;
  method: "post";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {};
  RequestQuery: {};
  RequestBody: {
    /** The label for the API token */
    label: string;
  };
  RequestHeaders: {};
  ResponseBody: UserAPITokenExtended;
  ResponseStatusCode: 201;
} = {
  route: "/user/tokens",
  method: "post",
  streaming: false,
  tags: ["users", "internal"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags users, internal
 * @name DeleteApiToken
 * @summary Delete an API token for user
 * @request DELETE:/user/tokens/{tokenId}
 * @secure
 */

// @ts-ignore
export const deleteAPIToken: {
  route: string;
  method: "delete";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The id of the API token */
    tokenId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 205;
} = {
  route: "/user/tokens/{tokenId}",
  method: "delete",
  streaming: false,
  tags: ["users", "internal"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Provides publicly available information about someone with a GitBook account.
 * @tags users, critical
 * @name GetUserById
 * @summary Get a user by its ID
 * @request GET:/users/{userId}
 * @secure
 */

// @ts-ignore
export const getUserById: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "high";
  tags: string[];
  RequestParams: {
    /** The unique ID of the User */
    userId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: User;
  ResponseStatusCode: 200 | 404;
} = {
  route: "/users/{userId}",
  method: "get",
  streaming: false,
  tags: ["users", "critical"],
  criticalityLevel: "high",
  deprecated: false,
};

/**
 * @description Update a GitBook account's details.
 * @tags users, critical
 * @name UpdateUserById
 * @summary Update a user by its ID
 * @request PATCH:/users/{userId}
 * @secure
 */

// @ts-ignore
export const updateUserById: {
  route: string;
  method: "patch";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "high";
  tags: string[];
  RequestParams: {
    /** The unique ID of the User */
    userId: string;
  };
  RequestQuery: {};
  RequestBody: {
    /**
     * Full name for the user
     * @minLength 1
     * @maxLength 64
     */
    displayName?: string;
    photoURL?: URL;
  };
  RequestHeaders: {};
  ResponseBody: User;
  ResponseStatusCode: 200 | 404;
} = {
  route: "/users/{userId}",
  method: "patch",
  streaming: false,
  tags: ["users", "critical"],
  criticalityLevel: "high",
  deprecated: false,
};

/**
 * No description
 * @tags users, critical, internal
 * @name SyncProfileWithAuth
 * @summary Sync the user's profile in the DB with their authentication account.
 * @request POST:/internal/profile/sync
 * @secure
 */

// @ts-ignore
export const syncProfileWithAuth: {
  route: string;
  method: "post";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "high";
  tags: string[];
  RequestParams: {};
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204;
} = {
  route: "/internal/profile/sync",
  method: "post",
  streaming: false,
  tags: ["users", "critical", "internal"],
  criticalityLevel: "high",
  deprecated: false,
};
